import React from "react";

export default function Logo({ variant = "dark" }) {
  const textColor = variant === "light" ? "text-white" : "text-[#1A1D14]";
  const subColor = variant === "light" ? "text-white/70" : "text-[#1A1D14]/60";
  const mColor = "#B29774";
  return (
    <div className="flex items-center gap-3">
      <svg width="36" height="36" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 34 V10 L12 18 L20 10 L28 18 L36 10 V34" stroke={mColor} strokeWidth="3" fill="none" strokeLinejoin="miter" />
      </svg>
      <div className="leading-none">
        <div className={`font-bold tracking-wide ${textColor} text-[15px]`}>
          MOHAN <span className="font-normal tracking-widest text-[11px] align-middle">LTD</span>
        </div>
        <div className={`text-[9px] tracking-[0.2em] mt-1 ${subColor}`}>CONSTRUCTION & BUILDING DEVELOPMENT</div>
      </div>
    </div>
  );
}
